import { render } from "./trainingProduct.vue?vue&type=template&id=2d8d5005&scoped=true&ts=true"
import script from "./trainingProduct.vue?vue&type=script&lang=ts"
export * from "./trainingProduct.vue?vue&type=script&lang=ts"

import "./trainingProduct.vue?vue&type=style&index=0&id=2d8d5005&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8d5005"]])

export default __exports__